import { IconsVariant } from "../../Components/Icon/Icon";
import { OrderSessionStatus } from "../v2/queries/interfacesV2";
import {
  AlarmFileSounds,
  OrderStatus,
  ProductEnum,
  ProductStatusEnums,
  ReceiptEnum,
} from "./enum";
import {
  CartItemStatus,
  CmsUserVariants,
  OnboardingActivityStatus,
  OrderStatusTypes,
  PosDeliveryMethodsProps,
  LanguagesProps,
} from "./interfaces";

export const cartStatusses = Object.keys(CartItemStatus).filter(
  (v) => !isNaN(Number(v))
);

export interface orderStatussesInterface {
  label: OrderStatusTypes;
  value: OrderStatus[];
  id: string;
  translationKey: string;
}
/* it can be max 2147483647 */
export const MAX_Z_INDEX = 2147483647;

export const orderStatusses: orderStatussesInterface[] = [
  {
    label: "Nieuw",
    value: [OrderStatus.ARRIVED, OrderStatus.CONFIRMED],
    id: "confirmed",
    translationKey: "new",
  },
  {
    label: "Keuken",
    value: [OrderStatus.IN_KITCHEN, OrderStatus.READY_FOR_PACKAGING],
    id: "in_kitchen",
    translationKey: "kitchen",
  },
  {
    label: "ReadyForDelivery",
    value: [OrderStatus.READY_FOR_DELIVERY],
    id: "ready_for_delivery",
    translationKey: "readyForDeliveryOrPickup",
  },
  {
    label: "Onderweg",
    value: [OrderStatus.EN_ROUTE, OrderStatus.HANDED_OVER],
    id: "enroute",
    translationKey: "enroute",
  },
];

export const statussen = [
  {
    label: "Nieuw",
    value: [1],
    id: "new",
    translationKey: "new",
  },
  {
    label: "Confirmed",
    value: [2],
    id: "confirmed",
    translationKey: "confirmed",
  },
  {
    label: "Keuken",
    value: [3],
    id: "in_kitchen",
    translationKey: "kitchen",
  },
  {
    label: "Onderweg",
    value: [4],
    id: "enroute",
    translationKey: "enroute",
  },
  {
    label: "Afgeleverd",
    value: [5],
    id: "handed_over",
    translationKey: "handed_over",
  },
  {
    value: [6],
    id: "order_cancelled",
    translationKey: "orderCancelled",
  },
  {
    value: [7],
    id: "ready_for_delivery_or_pickup",
    translationKey: "readyForDeliveryOrPickup",
  },
  {
    value: [9],
    id: "ready_for_packaging",
    translationKey: "readyForPackaging",
  },
  {
    value: [11],
    id: "canceled",
    translationKey: "cancelled",
  },
  {
    value: [12],
    id: "deleted",
    translationKey: "deleted",
  },
  {
    value: [13],
    id: "duplicated",
    translationKey: "duplicated",
  },
  {
    value: [14],
    id: "unpaid",
    translationKey: "unpaid",
  },
  {
    value: [15],
    id: "expired",
    translationKey: "expired",
  },
  {
    value: [16],
    id: "blocked",
    translationKey: "blocked",
  },
  {
    value: [17],
    id: "refunded",
    translationKey: "refunded",
  },
  {
    value: [18],
    id: "cleaning",
    translationKey: "cleaning",
  },
  {
    value: [19],
    id: "refused",
    translationKey: "refused",
  },
  {
    value: [20],
    id: "inTransit",
    translationKey: "inTransit",
  },
];

export const couriersMapStatusses = [
  statussen[1],
  statussen[2],
  statussen[3],
  statussen[6],
];

export const qrStatussessOptions = [...couriersMapStatusses, statussen[4]];

export const ordersFilters = [
  {
    value: [1],
    label: "arrived",
  },
  {
    value: [2],
    label: "confirmed",
  },
  {
    value: [3],
    label: "kitchen",
  },
  {
    value: [4],
    label: "enroute",
  },
  {
    value: [5],
    label: "handed_over",
  },
  {
    value: [11],
    label: "orderCancelled",
  },
];

export const posSources = [
  {
    label: "Pos Order",
    value: [19],
    translationKey: "posOrder",
    icon: "utensils",
    fill: "dark",
    size: "2.25rem",
  },
  {
    label: "Website",
    value: [4, 17, 20, 18, 21, 22],
    translationKey: "website",
    icon: "desktop",
    fill: "dark",
    size: "2.5rem",
  },
  {
    label: "External",
    value: [5, 7, 8],
    translationKey: "external",
    icon: "arrowUpRight",
    fill: "dark",
    size: "2.5rem",
  },
];

export type DeliveryMethod = {
  id: string;
  label: string;
  value: number;
  icon?: IconsVariant;
  translationKey: string;
};
export const deliveryMethods: Partial<DeliveryMethod[]> = [
  {
    id: "Bezorgen",
    label: "Bezorgen",
    value: 1,
    icon: "scooter",
    translationKey: "delivery",
  },
  {
    id: "Afhalen",
    label: "Afhalen",
    value: 2,
    icon: "package",
    translationKey: "takeAway",
  },
  {
    id: "dinerenIn",
    label: "Dineren in",
    value: 3,
    translationKey: "dineIn",
  },
  {
    id: "posOrder",
    label: "Pos Order",
    value: 4,
    icon: "package",
    translationKey: "posOrder",
  },
  {
    id: "qrTableOrder",
    label: "Qr Table Order",
    value: 5,
    translationKey: "qrTableOrder",
  },
  {
    id: "orderKiosk",
    label: "Order Kiosk",
    value: 6,
    translationKey: "orderKiosk",
  },
  {
    id: "waiterOrder",
    label: "Waiter Order",
    value: 7,
    translationKey: "waiterOrder",
  },
  {
    id: "deliveryByExternal",
    label: "Delivery by external",
    value: 8,
    icon: "scooter",
    translationKey: "deliveryByExternal",
  },
  {
    id: "takeout",
    label: "Takeout",
    value: 9,
    translationKey: "takeout",
  },
];

export const kioskDeliveryMethods = [deliveryMethods[2], deliveryMethods[8]];

export const deliveryMethodsEnum = {
  1: "delivery",
  2: "takeAway",
  3: "dineIn",
  4: "posOrder",
  5: "qrTableOrder",
  6: "orderKiosk",
  7: "waiterOrder",
  8: "deliveryByExternal",
  9: "takeout",
};

export const Languages: LanguagesProps[] = [
  { value: "all", label: "Standaard" },
  { value: "dutch", icon: "netherlands", label: "nl", text: "Nederlands" },
  { value: "english", icon: "greatebritain", label: "gb", text: "English" },
  { value: "turkish", icon: "turkiye", label: "tr", text: "Türkçe" },
  { value: "chinese", icon: "cny", label: "cny", text: "中国人" },
];

export const financialPaymentMethods = [
  { translationKey: "allPaymentMethods", value: 1000 },
  { translationKey: "cash", value: 1 },
  { translationKey: "iDeal", value: 2 },
  { translationKey: "creditcard", value: 10 },
];

export const versionIncreamentTypes = [
  { translationKey: "bugFix", value: 1 },
  { translationKey: "newFeature", value: 2 },
  { translationKey: "improvements", value: 3 },
];

export const financialDeliveryMethods = [
  { translationKey: "allDeliveryMethods", value: 0 },
  { translationKey: "delivery", value: 1 },
  { translationKey: "Takeaway", value: 2 },
  { translationKey: "dineIn", value: 3 },
  { translationKey: "posOrder", value: 4 },
  { translationKey: "deliveryByExternal", value: 8 },
  { translationKey: "takeOut", value: 9 },
];

export const posDeliveryMethods: PosDeliveryMethodsProps[] = [
  // { translationKey: "all", value: 0 },
  { translationKey: "delivery", value: 1, icon: "scooter" },
  { translationKey: "takeAway", value: 2, icon: "package" },
  { translationKey: "atTable", value: 3, icon: "table" },
  { translationKey: "posOrder", value: 4, icon: "cashRegister" },
];

export const financialFrequency = [
  { translationKey: "hourly", value: 7 },
  { translationKey: "calendar_day", value: 1 },
  { translationKey: "opening_time_day", value: 2 },
  { translationKey: "weekly", value: 3 },
  { translationKey: "month", value: 4 },
  { translationKey: "quarter", value: 5 },
  { translationKey: "year", value: 6 },
];

export const revenueTypes = [
  { translationKey: "revenue", value: 5 },
  { translationKey: "quantity", value: 6 },
];

export const chartLoadingState = {
  options: {
    noData: {
      text: "Loading...",
      pageNumberX: 0,
      pageNumberY: 0,
      style: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Helvetica",
      },
    },
    chart: {
      id: "basic-bar",
    },
    xaxis: {
      categories: ["-", "-", "-", "-", "-", "-"],
    },
  },
  series: [],
};

export const actionMessages = {
  favourite: "makeFavorite",
  defavourite: "removeFavorite",
  visible: "makeVisible",
  hide: "removeVisible",
  active: "activate",
  deactive: "deactive",
  trash: "delete",
  detrash: "detrash",
};

const minIncrements = 12;
export const increments = (
  format = (v) => {
    return `+${v} min`;
  },
  startPoint?: number,
  custom?: number
) => {
  const retVal = Array.from(Array(minIncrements)).map((_, k) => ({
    value: (k + (startPoint || 0)) * 5,
    label: `${format((k + (startPoint || 0)) * 5)}`,
  }));
  if (custom) {
    retVal.push({ value: custom, label: `${format(custom)}` });
  }

  return retVal;
};

export const themeActionType = {
  EDIT: "EDIT",
  CREATE: "CREATE",
};

export const themeType = {
  DEFAULT: "DEFAULT",
  CUSTOM: "CUSTOM",
};

export const MAX_IMAGE_COUNT = 5;

export const minute = 60;

export const newLabelShowMinute = 5;

export const userRoles = {
  ROLE_APPSMEN_SHAREHOLDER: "ROLE_APPSMEN_SHAREHOLDER",
  ROLE_APPSMEN_ADMIN: "ROLE_APPSMEN_ADMIN",
  ROLE_CUSTOM: "ROLE_CUSTOM",
  ROLE_APPSMEN_EMPLOYEE: "ROLE_APPSMEN_EMPLOYEE",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_USER: "ROLE_USER",
  ROLE_ACCOUNTANT: "ROLE_ACCOUNTANT",
  ROLE_COURIER: "ROLE_COURIER",
  ROLE_COURIER_ADMIN: "ROLE_COURIER_ADMIN",
  ROLE_ORDER_TRACKER: "ROLE_ORDER_TRACKER",
  ROLE_MENU: "ROLE_MENU",
  ROLE_ORDER_USER: "ROLE_ORDER_USER",
  ROLE_CMS_ACCOUNT: "ROLE_CMS_ACCOUNT",
  ROLE_SITE_ADMIN: "ROLE_SITE_ADMIN",
  ROLE_ORDER_ARCHIVE: "ROLE_ORDER_ARCHIVE",
  ROLE_ZIP_CODES: "ROLE_ZIP_CODES",
  ROLE_OPENING_TIMES: "ROLE_OPENING_TIMES",
  ROLE_MARKETEER: "ROLE_MARKETEER",
  ROLE_WAITER: "ROLE_WAITER",
  ROLE_COURIER_READ: "ROLE_COURIER_READ",
  ROLE_COURIER_WRITE: "ROLE_COURIER_WRITE",
  ROLE_COURIER_PATCH: "ROLE_COURIER_PATCH",
  ROLE_COURIER_DELETE: "ROLE_COURIER_DELETE",
  ROLE_MENU_READ: "ROLE_MENU_READ",
  ROLE_MENU_WRITE: "ROLE_MENU_WRITE",
  ROLE_MENU_PATCH: "ROLE_MENU_PATCH",
  ROLE_MENU_DELETE: "ROLE_MENU_DELETE",
  ROLE_ORDER_USER_READ: "ROLE_ORDER_USER_READ",
  ROLE_ORDER_USER_WRITE: "ROLE_ORDER_USER_WRITE",
  ROLE_ORDER_USER_PATCH: "ROLE_ORDER_USER_PATCH",
  ROLE_ORDER_USER_DELETE: "ROLE_ORDER_USER_DELETE",
  ROLE_ORDER_TRACKER_READ: "ROLE_ORDER_TRACKER_READ",
  ROLE_ORDER_TRACKER_WRITE: "ROLE_ORDER_TRACKER_WRITE",
  ROLE_ORDER_TRACKER_PATCH: "ROLE_ORDER_TRACKER_PATCH",
  ROLE_ORDER_TRACKER_DELETE: "ROLE_ORDER_TRACKER_DELETE",
  ROLE_ORDER_ARCHIVE_READ: "ROLE_ORDER_ARCHIVE_READ",
  ROLE_ORDER_ARCHIVE_WRITE: "ROLE_ORDER_ARCHIVE_WRITE",
  ROLE_ORDER_ARCHIVE_PATCH: "ROLE_ORDER_ARCHIVE_PATCH",
  ROLE_ORDER_ARCHIVE_DELETE: "ROLE_ORDER_ARCHIVE_DELETE",
  ROLE_ZIP_CODES_READ: "ROLE_ZIP_CODES_READ",
  ROLE_ZIP_CODES_WRITE: "ROLE_ZIP_CODES_WRITE",
  ROLE_ZIP_CODES_PATCH: "ROLE_ZIP_CODES_PATCH",
  ROLE_ZIP_CODES_DELETE: "ROLE_ZIP_CODES_DELETE",
  ROLE_OPENING_TIMES_READ: "ROLE_OPENING_TIMES_READ",
  ROLE_OPENING_TIMES_WRITE: "ROLE_OPENING_TIMES_WRITE",
  ROLE_OPENING_TIMES_PATCH: "ROLE_OPENING_TIMES_PATCH",
  ROLE_OPENING_TIMES_DELETE: "ROLE_OPENING_TIMES_DELETE",
  ROLE_FINANCIAL_READ: "ROLE_FINANCIAL_READ",
  ROLE_DAY_REPORT: "ROLE_DAY_REPORT",
  ROLE_FINANCIAL_WRITE: "ROLE_FINANCIAL_WRITE",
  ROLE_FINANCIAL_PATCH: "ROLE_FINANCIAL_PATCH",
  ROLE_FINANCIAL_DELETE: "ROLE_FINANCIAL_DELETE",
  ROLE_CMS_ACCOUNT_READ: "ROLE_CMS_ACCOUNT_READ",
  ROLE_CMS_ACCOUNT_WRITE: "ROLE_CMS_ACCOUNT_WRITE",
  ROLE_CMS_ACCOUNT_PATCH: "ROLE_CMS_ACCOUNT_PATCH",
  ROLE_CMS_ACCOUNT_DELETE: "ROLE_CMS_ACCOUNT_DELETE",
  ROLE_SITE_ADMIN_READ: "ROLE_SITE_ADMIN_READ",
  ROLE_SITE_ADMIN_WRITE: "ROLE_SITE_ADMIN_WRITE",
  ROLE_SITE_ADMIN_PATCH: "ROLE_SITE_ADMIN_PATCH",
  ROLE_SITE_ADMIN_DELETE: "ROLE_SITE_ADMIN_DELETE",
  ROLE_MARKETEER_READ: "ROLE_MARKETEER_READ",
  ROLE_MARKETEER_WRITE: "ROLE_MARKETEER_WRITE",
  ROLE_MARKETEER_PATCH: "ROLE_MARKETEER_PATCH",
  ROLE_MARKETEER_DELETE: "ROLE_MARKETEER_DELETE",
  ROLE_DISCOUNTS_READ: "ROLE_DISCOUNTS_READ",
};

export const fontFamilyOptions = [
  { label: "arial", value: "Arial" },
  { label: "serif", value: "Serif" },
  { label: "monospace", value: "Monospace" },
];

export const qrPositionOptions = [
  { label: "top", value: 1 },
  { label: "bottom", value: 2 },
];
export const logoPositionOptions = [
  { label: "top", value: 1 },
  { label: "bottom", value: 2 },
];
export const orderRemarksFontWeightOptions = [
  { label: "normal", value: "normal" },
  { label: "bold", value: "bold" },
];

export const categoryNamePositionOptions = [
  { label: "topProduct", value: 1 }, //SEPARATED
  { label: "leftProduct", value: 2 }, //SAME_LINE
];

export const receiptSourceOptions = [
  { label: "all_sources", value: 100 },
  { label: "website", value: 4 },
  { label: "thuisbezorgd_nl", value: 5 },
  { label: "uber_eats", value: 7 },
  { label: "homie", value: 8 },
  { label: "ios_web_app", value: 17 },
  { label: "android_web_app", value: 18 },
  { label: "pos", value: 19 },
  { label: "ios_native_app", value: 20 },
  { label: "android_native_app", value: 21 },
  { label: "kiosk", value: 23 },
];

export const informationAlignmentOptions = [
  { label: "vertical", value: 1 },
  { label: "horizontal", value: 2 },
  { label: "logoAtTopAndHorizontal", value: 3 },
];

export const getLabelForBulkStatus = (id: number) => {
  const data = {
    1: "push.sent",
    2: "push.not_sent",
    3: "push.failed_sent",
    4: "push.experid",
    5: "push.being_sent",
    6: "push.error",
  };

  return data[id];
};

export const cmsUserStatus: CmsUserVariants[] = [
  { id: 1, translationKey: "active", variant: "success" },
  { id: 20, translationKey: "deleted", variant: "error" },
  { id: 21, translationKey: "suspended", variant: "warning" },
  { id: 22, translationKey: "awaitingActivation", variant: "info" },
];

export const notificationMethodOptions = [
  { id: 1100001, translationKey: "sms", value: "SMS" },
  { id: 1100002, translationKey: "email", value: "EMAIL" },
  { id: 1100003, translationKey: "push", value: "PUSH" },
];

export const chartColors = [
  "#008FFB",
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#8D5B4C",
  "#A5978B",
  "#5C4742",
  "#C4BBAF",
  "#5A2A27",
  "#D7263D",
  "#1B998B",
  "#2E294E",
  "#F46036",
  "#E2C044",
  "#2B908F",
  "#F9A3A4",
  "#90EE7E",
  "#FA4443",
  "#69D2E7",
];

export const supportedWebsiteLanguages = [
  { label: "dutch", value: 1, isActive: true },
  { label: "german", value: 2, isActive: false },
  { label: "english", value: 3, isActive: false },
  { label: "french", value: 4, isActive: false },
  { label: "spanish", value: 5, isActive: false },
  { label: "turkish", value: 6, isActive: false },
  { label: "serbian", value: 7, isActive: false },
  { label: "belgiumDutch", value: 8, isActive: false },
  { label: "belgiumFrench", value: 9, isActive: false },
  { label: "chinese", value: 10, isActive: false },
  { label: "polish", value: 11, isActive: false },
  { label: "arabic", value: 12, isActive: false },
  { label: "russian", value: 13, isActive: false },
  { label: "italian", value: 14, isActive: false },
  { label: "punjabi", value: 15, isActive: false },
  { label: "hindi", value: 16, isActive: false },
  { label: "urdu", value: 17, isActive: false },
  { label: "japanese", value: 18, isActive: false },
  { label: "korean", value: 19, isActive: false },
];

export const countryLanguages: Partial<{
  label: string;
  value: number;
  isActive: boolean;
  key: string;
  country: number;
  icon: IconsVariant;
  shorten: string;
  text: string;
}>[] = [
  {
    label: "standaard",
    value: 0,
    isActive: false,
    key: "all",
    shorten: "all",
    text: "All",
  },
  {
    label: "dutch",
    value: 1,
    isActive: false,
    key: "nl",
    country: 1,
    icon: "netherlands",
    shorten: "nl",
    text: "Nederlands",
  },
  {
    label: "german",
    value: 2,
    isActive: false,
    key: "de",
    icon: "german",
    shorten: "d",
    text: "German",
  },
  {
    label: "english",
    value: 3,
    isActive: false,
    key: "en",
    icon: "greatebritain",
    shorten: "gb",
    text: "English",
  },
  {
    label: "french",
    value: 4,
    isActive: false,
    key: "french",
    icon: "french",
    shorten: "f",
    text: "French",
  },
  {
    label: "spanish",
    value: 5,
    isActive: false,
    key: "spanish",
    icon: "spain",
    shorten: "e",
    text: "Spanish",
  },
  {
    label: "turkish",
    value: 6,
    isActive: false,
    key: "tr",
    icon: "turkiye",
    shorten: "tr",
    text: "Türkçe",
  },
  {
    label: "serbian",
    value: 7,
    isActive: false,
    key: "sr",
    icon: "serbia",
    shorten: "srb",
    text: "Serbian",
  },
  {
    label: "belgiumDutch",
    value: 8,
    isActive: false,
    key: "nl_be",
    country: 2,
    icon: "belgiumDutch",
    text: "belgiumDutch",
  },
  {
    label: "belgiumFrench",
    value: 9,
    isActive: false,
    key: "fr_be",
    icon: "belgiumFrench",
    text: "belgiumFrench",
  },
  {
    label: "chinese",
    value: 10,
    isActive: false,
    key: "zh",
    icon: "cny",
    shorten: "cny",
    text: "中国人",
  },
  {
    label: "polish",
    value: 11,
    isActive: false,
    key: "pl",
    icon: "polish",
    shorten: "pl",
    text: "Polski",
  },
  {
    label: "arabic",
    value: 12,
    isActive: false,
    key: "sa",
    icon: "saudiArabia",
    shorten: "sa",
    text: "المملكة العربية السعودية",
  },
];

export const posMenuColors = [
  "#012a4a",
  "#013a63",
  "#01497c",
  "#014f86",
  "#2a6f97",
  "#2c7da0",
  "#468faf",
  "#61a5c2",
];

export const DEFAULT_ALARM_VOLUME = 3;
export const DEFAULT_EXTRA_ALARM_MINUTE_DELAY = 0;

export const dayTypeOptions = [
  { translationKey: "calendarDay", value: 1 },
  { translationKey: "openingTimeDay", value: 2 },
  { translationKey: "handOverTimeDay", value: 3 },
];

export const receiptInformationPositions = [
  { translationKey: "logoPosition", value: 1 },
  { translationKey: "orderUserInfoPosition", value: 2 },
  { translationKey: "orderInfoPosition", value: 3 },
  { translationKey: "branchInfoPosition", value: 4 },
  { translationKey: "qrInfoPosition", value: 5 },
];

export const targets: {
  label: string;
  value: number;
  icon: IconsVariant;
}[] = [
  { label: "all", value: 0, icon: "th" },
  { label: "delivery", value: 1, icon: "scooter" },
  { label: "takeAway", value: 2, icon: "package" },
  { label: "dineIn", value: 3, icon: "table" },
  { label: "takeOut", value: 9, icon: "package" },
  { label: "posOrder", value: 4, icon: "cashRegister" },
  { label: "qrTableOrder", value: 5, icon: "qr" },
  { label: "waiterOrder", value: 7, icon: "userTie" },
];

export const targetsWithoutAll = targets.slice(1);

export const generalToastId = "generalToastId";

export const soundOptions: { label: string; value: number }[] = [
  { label: "sound_popup.doorbell", value: AlarmFileSounds.DOOR_BELL },
  { label: "sound_popup.guitar", value: AlarmFileSounds.GUITAR },
  { label: "sound_popup.joyous", value: AlarmFileSounds.JOYOUS },
  { label: "sound_popup.proud", value: AlarmFileSounds.PROUD },
  { label: "sound_popup.relax", value: AlarmFileSounds.RELAX },
  { label: "sound_popup.upset", value: AlarmFileSounds.UPSET },
  { label: "sound_popup.gong", value: AlarmFileSounds.GONG },
];

export const productEnumOptions = [
  { translationKey: "restaurant", value: ProductEnum.RESTAURANT },
  { translationKey: "nightShop", value: ProductEnum.NIGHT_SHOP },
];

export const receiptMap = {
  // prettier-ignore
  [ReceiptEnum.Default_Receipt]: ["1" , "2" ,"3" , "4" , "5", "6", "7", "8" ,"9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34" , "35" , "36" ,"40" , "41" , "42" , "43"],
  // prettier-ignore
  [ReceiptEnum.Default_Receipt2]: ["1", "2", "3" , "4" , "5", "6", "7", "8" ,"9", "10", "12", "13", "15", "16", "17", "18", "23", "24", "25", "31", "32", "33", "34" , "35" ,"36" , "40" , "41" , "42" , "43"],
  // prettier-ignore
  [ReceiptEnum.Default_Receipt3]: ["1", "2", "3" , "4" , "5", "6", "7", "8" ,"9", "10", "12", "13", "15", "16", "18", "23", "25", "31", "32", "33", "34" , "35" ,"36" , "40" , "41" , "42" , "43"],
  // prettier-ignore
  [ReceiptEnum.Default_Receipt_Label]: ["1", "2", "3", "4", "5", "6", "7", "8" , "22" , "37" , "38" , "39" , "40"],
};

export const superAdminRoles = [
  "ROLE_APPSMEN_EMPLOYEE",
  "ROLE_SUPER_ADMIN",
  "ROLE_APPSMEN_ADMIN",
];

export const adminRoles = ["ROLE_ADMIN", ...superAdminRoles];

export const MAX_ORDER_COUNT_FOR_OTHERS = 10;
export const MAX_ORDER_COUNT_FOR_ARRIVED = 50;
export const allSources = [4, 17, 18, 20, 21, 5, 7, 8, 19, 22, 24];
export const allDeliveryMethods = deliveryMethods.map((method) => method.value);

export const onboardingStatuses = Object.entries(OnboardingActivityStatus).map(
  ([label, value]) => ({
    label: label.toLowerCase(),
    value: parseInt(value),
  })
);

export const sessionOrderStatus = [
  { translationKey: "active", value: OrderSessionStatus.ACTIVE },
  { translationKey: "finished", value: OrderSessionStatus.FINISHED },
  {
    translationKey: "waitingForPayment",
    value: OrderSessionStatus.WAITING_FOR_PAYMENT,
  },
  {
    translationKey: "waitingForWaiter",
    value: OrderSessionStatus.WAITING_FOR_WAITER,
  },
  { translationKey: "cancelled", value: OrderSessionStatus.CANCELLED },
];

export const productStatus = [
  { label: "available", value: ProductStatusEnums.AVAILABLE },
  { label: "soldOut", value: ProductStatusEnums.SOLD_OUT },
  { label: "notAvailable", value: ProductStatusEnums.OUT_OF_STOCK },
  { label: "soldOutForToday", value: ProductStatusEnums.SOLD_OUT_FOR_TODAY },
];

export const mapZoomLevels = [
  {
    label: "City overview",
    value: 11,
    id: "city",
    translationKey: "zoomLevelCity",
  },
  {
    label: "Neighborhood",
    value: 13,
    id: "neighborhood",
    translationKey: "zoomLevelNeighborhood",
  },
  {
    label: "Street level",
    value: 14,
    id: "street",
    translationKey: "zoomLevelStreet",
  },
  {
    label: "Building level",
    value: 15,
    id: "building",
    translationKey: "zoomLevelBuilding",
  },
];
